export default function configureSelect2(container) {
  var INVALID_PARENT_ID = -1;

  $(".nested-level-input, .search-select-input", container).each(function (i, el) {
    var element = $(el);
    var fields = element.data("fields");
    var predicate = element.data("predicate");
    var filters = element.data("filters");
    var displayName = element.data("display-name");
    var parent = element.data("parent");
    var width = element.data("width");
    var model = element.data("model");
    var responseRoot = element.data("response-root");
    var collection = element.data("collection");
    var minimumInputLength = element.data("minimum-input-length");
    var order = element.data("order");
    var parentId = element.data("parent-id");
    var selectInstance;

    var select2Config = {
      width: width,
      minimumInputLength: minimumInputLength,
      placeholder: "",
      allowClear: true,
    };

    if (collection) {
      select2Config.dataAdapter = $.fn.select2.amd.require("select2/data/nestedCustomAdapter");
    } else {
      var ajaxConfig = {
        url: function () {
          var url = element.attr("data-url");
          return url;
        },
        dataType: "json",
        delay: 250,
        cache: true,
        data: function (params) {
          var textQuery = { m: "or" };
          fields.forEach(function (field) {
            if (field == "id") {
              textQuery[field + "_eq"] = params.term;
            } else {
              textQuery[field + "_" + predicate] = params.term;
            }
          });

          var query = {
            order: order,
            q: {
              groupings: [textQuery],
              combinator: "and",
            },
          };

          if (parent) {
            query.q[parent + "_eq"] = parentId;
          }

          Object.assign(query.q, filters);

          return query;
        },
        processResults: function (data) {
          if (data.constructor == Object) {
            data = data[responseRoot];
          }

          return {
            results: jQuery.map(data, function (resource) {
              if (!resource[displayName]) {
                resource[displayName] = "No display name for id #" + resource.id.toString();
              }
              return {
                id: resource.id,
                text: resource[displayName].toString(),
              };
            }),
          };
        },
      };

      select2Config.ajax = ajaxConfig;
    }

    selectInstance = element.select2(select2Config);

    function setParentValue(e) {
      selectInstance.val(null).trigger("select2:select").trigger("change");
      parentId = e.params && e.params.data.id ? e.params.data.id : INVALID_PARENT_ID;
      element.data("parent-id", parentId);
    }

    if (parent) {
      var parentSelectorId = "#" + model + "_" + parent;
      if (!$(parentSelectorId).length) {
        parentSelectorId = $(container).find("*[id*=" + parent + "]")[0];
      }
      var parentSelector = $(parentSelectorId)[0];

      $(parentSelector).on("select2:select", setParentValue);
      $(parentSelector).on("select2:unselect", setParentValue);
    }
  });
}
